export enum kind {
    exercises = "Single Exercise",
    routines = "Routines",
    phase = "Program Phase",
    programs = "Program"
}